import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { TextInputComponent } from '../../../../components/TextInputComponent'
import { corporateColor } from '../../../../theme/colors'
import { FuelTank } from '../types'
import { DOBRA } from '../../../../theme/fonts'

interface Props {
  fuelTank: FuelTank
  onChange: (values: { fuelTankId: number; stock: string }) => void
  value: string
}
export const Item = ({ fuelTank, onChange, value }: Props) => {
  const handleOnChange = (value: string) => {
    if (fuelTank.nominal_capacity >= +value) {
      onChange({ fuelTankId: fuelTank.id_fuel_tank, stock: value })
    }
  }

  return (
    <View style={{ flexDirection: 'row', alignContent: 'center', marginBottom: 16 }}>
      <View style={{ flex: 1.2, justifyContent: 'center', height: 44, flexWrap: 'nowrap' }}>
        <Text style={style.bodyLabel}>{fuelTank.name}</Text>
      </View>
      <View style={{ flex: 1, justifyContent: 'center' }}>
        <Text style={style.bodyLabel}>{fuelTank.nominal_capacity} lt</Text>
      </View>
      <View style={{ flex: 1, justifyContent: 'center' }}>
        <Text style={style.bodyLabel}>{fuelTank.usable_capacity} lt</Text>
      </View>
      <View style={{ flex: 1.2, justifyContent: 'center' }}>
        <TextInputComponent
          onChange={handleOnChange}
          value={value}
          customStyles={{
            container: { flex: 0.8 },
            input: { marginTop: 0 },
          }}
          keyboardType='numeric'
        />
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  bodyLabel: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 16,
    lineHeight: 20,
    fontWeight: '400',
    flexWrap: 'nowrap',
  },
})
